import React, { useState } from "react";
import CardBody from "../../../components/Card/CardBody";
import { Button, GridLegacy, TextField, Tooltip, Typography, Alert } from "@mui/material";
import Card from "../../../components/Card/Card";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { convertObjectToSelectOptions } from "../../../templateHelpers";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useController, useFieldArray, useFormContext, useWatch } from "react-hook-form";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import { useVestigingContext } from "../../../components/Forms/VestigingProvider";
import { displayOnScreen } from "../../../variables/app";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { makeid } from "../../Vestigingen/Tabs/V5/Fonts/CustomFonts";
import axios from "axios";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";

function Algemeen() {
  const { vestigingId, menukaartVestigingId } = useFormContext();
  const { vestiging } = useVestigingContext();
  const appTarget = vestiging?.appTarget;
  const menukaartenString = useWatch({ name: "menukaart" });
  const scheduledActions = useWatch({ name: "scheduled_actions" });
  const isSystemProduct = useWatch({ name: "is_system_product" });
  const systemProductVariant = useWatch({ name: "system_product_variant" });
  const [eanString, setEanString] = useState("");

  const [scheduledActionsState, setScheduledActionsState] = useState(scheduledActions);

  const menukaarten = menukaartenString != null ? JSON.parse(menukaartenString) : [];
  const kitchenDisplay = convertObjectToSelectOptions(displayOnScreen);
  const menukaartFormFieldProps = {};
  const { fields, append, remove } = useFieldArray({
    name: "eans",
  });

  if (appTarget === "appv5.js" || menukaarten?.length > 1) {
    menukaartFormFieldProps.multiple = true;
    menukaartFormFieldProps.name = "menukaart";
  } else {
    menukaartFormFieldProps.name = "menukaart_id";
  }

  const scheduledActionsAlerts = (scheduledActionsState ?? []).map((scheduledAction) => {
    let alertMsg = "";

    if (scheduledAction.property === "blocked" && scheduledAction.new_value === "0") {
      alertMsg += getTranslation("producten.form.algemeen.alert.at", "At");
      alertMsg += " [" + scheduledAction.execute_at + "] ";
      alertMsg += getTranslation("producten.form.algemeen.label.blocked", "Block in jamezz");
      alertMsg += " ";
      alertMsg += getTranslation("producten.form.algemeen.alert.set_to_false", "will be set to false!");
    } else {
      return "";
    }

    return (
      <Alert
        action={
          <Button
            color={"inherit"}
            onClick={() => {
              axios
                .post("core/producten/deleteActionItem", {
                  action_item_id: scheduledAction.action_item_id,
                })
                .then(() => {
                  setScheduledActionsState(
                    scheduledActionsState.filter((filterScheduledAction) => {
                      return scheduledAction.action_item_id !== filterScheduledAction.action_item_id;
                    })
                  );
                })
                .catch((error) => {
                  if (error.status === 404) {
                    setScheduledActionsState(
                      scheduledActionsState.filter((filterScheduledAction) => {
                        return scheduledAction.action_item_id !== filterScheduledAction.action_item_id;
                      })
                    );
                  }
                });
            }}
            size={"small"}
          >
            <TranslationWrapper tKey={"Abort"} />
          </Button>
        }
        key={"deleteActionItemAlert"}
        severity={"warning"}
        style={{ marginBottom: "16px" }}
      >
        {alertMsg}
      </Alert>
    );
  });

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      {scheduledActionsAlerts}
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormSwitchTC
                name={"blocked"}
                tDefault={"Blokkeren in jamezz"}
                tKey={"producten.form.algemeen.label.blocked"}
              />
              <FormSwitchTC
                name={"is_actief"}
                tDefault={"Actief (systeem)"}
                tKey={"producten.form.algemeen.label.is_actief"}
              />
              <FormSwitchTC
                name={"sActive"}
                tDefault={"Actief (overwrite)"}
                tKey={"producten.form.algemeen.label.sActive"}
              />
              <FormTextTC
                name={"naam"}
                tDefault={"Productnaam (overwritten)"}
                tKey={"producten.form.algemeen.label.naam"}
              />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"snaam"}
                tDefault={"Productnaam (systeem)"}
                tKey={"producten.form.algemeen.label.snaam"}
              />
              <FormTextTC name={"printName"} tDefault={"Printname"} tKey={"producten.form.algemeen.label.printName"} />

              <FormFieldTwoColumns tDefault={"Is system product"} tKey={"producten.form.algemeen.is_system_product"}>
                <Tooltip title={systemProductVariant}>
                  <span>{isSystemProduct ? "yes" : "no"}</span>
                </Tooltip>
              </FormFieldTwoColumns>
              <FormAsyncTC
                async={{
                  url:
                    "core/kaarten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    vestigingId,
                  searchField: "naam",
                }}
                key={"menukaart_id" + vestigingId + "-" + (menukaartFormFieldProps.multiple ? "multiple" : "single")}
                nullable={true}
                tDefault={"Groep"}
                tKey={"producten.form.algemeen.label.menukaart_id"}
                {...menukaartFormFieldProps}
              />
              <FormTextTC
                name={"omschrijving"}
                rows={5}
                tDefault={"Product description (System)"}
                tKey={"producten.form.algemeen.label.omschrijving"}
              />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"somschrijving"}
                rows={5}
                tDefault={"Product description (System)"}
                tKey={"producten.form.algemeen.label.somschrijving"}
              />
            </GridLegacy>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"id"}
                tDefault={"#"}
                tKey={"producten.form.algemeen.label.id"}
              />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"externalId"}
                tDefault={"# API"}
                tKey={"producten.form.algemeen.label.externalId"}
              />
              <FormTextTC name={"apiId1"} tDefault={"# API"} tKey={"producten.form.algemeen.label.externalId"} />
              <FormAsyncTC
                async={{
                  url: "core/printers/search?fields=id as value, name as label&per_page=50&vestiging_id=" + vestigingId,
                  searchField: "name",
                }}
                key={"printer_id" + vestigingId}
                name={"printer_id"}
                nullable={true}
                tDefault={"Printer"}
                tKey={"producten.form.algemeen.label.printer_id"}
              />
              <FormControlledInputTC
                decimals={0}
                name={"stock"}
                rules={{
                  pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
                }}
                tDefault={"Voorraad"}
                tKey={"producten.form.algemeen.label.stock"}
                type={"number"}
              />
              <FormTextTC name={"ean"} tDefault={"# EAN"} tKey={"producten.form.algemeen.label.ean"} />

              <div style={{ width: "100%" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "8px 0px",
                    paddingRight: "32px",
                  }}
                >
                  <Typography
                    style={{
                      color: "rgba(0, 0, 0, 0.54)",
                      padding: "0",
                      fontSize: "1rem",
                      fontWeight: "400",
                      lineHeight: "1",
                      marginTop: "21px",
                    }}
                  >
                    <TranslationWrapper tKey={"# EANS"} />
                  </Typography>

                  <div
                    style={{
                      width: "65%",
                      display: "flex",
                    }}
                  >
                    <TextField
                      label={<TranslationWrapper tKey={"Add new ean"} />}
                      onChange={(e) => {
                        setEanString(e.target.value);
                      }}
                      style={{ width: "100%" }}
                      value={eanString}
                    />
                    <Button
                      color={"primary"}
                      onClick={() => {
                        if (eanString.length > 0) {
                          let uuid = "";
                          if (window.crypto?.randomUUID) {
                            uuid = window.crypto.randomUUID();
                          } else {
                            uuid = makeid(32);
                          }
                          append({ id: uuid, value: { id: eanString, price: "" } });
                          setEanString("");
                        }
                      }}
                      size={"small"}
                      variant={"contained"}
                    >
                      +
                    </Button>
                  </div>
                </div>
                {fields?.length > 0 ? (
                  <div
                    style={{
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    {fields?.map((field, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "solid 1px lightgray",
                            padding: "10px",
                            marginBottom: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ color: "rgba(0, 0, 0, 0.54)", marginRight: "5px" }}>EAN |</div>
                            <Typography>{field.value.id}</Typography>
                            {field.value.price.length > 0 ? (
                              <small style={{ marginLeft: "5px", alignSelf: "flex-start" }}>
                                (<TranslationWrapper tDefault={"price"} tKey={"eans.price"} />: {field.value.price})
                              </small>
                            ) : null}
                          </div>
                          <div>
                            <Button
                              color={"primary"}
                              onClick={() => {
                                remove(index);
                              }}
                              style={{ padding: "0 0 0 0" }}
                            >
                              <TranslationWrapper tDefault={"Remove"} tKey={"eans.remove"} />
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
              <FormAsyncTC
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    menukaartVestigingId,
                  searchField: "naam",
                }}
                key={"depositId" + menukaartVestigingId}
                name={"depositId"}
                tDefault={"Deposit product"}
                tKey={"producten.form.algemeen.label.depositId"}
              />
              <FormSwitchTC
                name={"cartAfterAdding"}
                tDefault={"Go to shopping basket after adding this product"}
                tKey={"producten.form.algemeen.label.cartAfterAdding"}
              />
              <FormSwitchTC
                name={"tipProduct"}
                tDefault={"TIP Product"}
                tKey={"producten.form.algemeen.label.tipProduct"}
              />
              <FormTextTC name={"ledger"} tDefault={"# Ledger"} tKey={"producten.form.algemeen.label.ledger"} />
              <FormSwitchTC
                name={"fillerProduct"}
                tDefault={"Filler product"}
                tKey={"producten.form.algemeen.label.filler"}
              />
              <FormSwitchTC
                name={"checkStockAPI"}
                tDefault={"Check API stock"}
                tKey={"producten.form.algemeen.label.checkStockAPI"}
              />
              <FormSwitchTC
                defaultValue={true}
                name={"sentToApi"}
                tDefault={"Send to API"}
                tKey={"producten.form.algemeen.label.sentToApi"}
              />
              <FormSelectTC
                name={"onOrderscreen"}
                options={kitchenDisplay}
                tDefault={"Display on order screen"}
                tKey={"producten.form.algemeen.label.onOrderscreen"}
              />
              {/*  <FormSwitchTC
                name={"showOnAllKsWithItems"}
                tKey={"producten.form.algemeen.label.showOnAllKsWithItems"}
                tDefault={"Show on all screens with products"}
              />*/}
              <FormSwitchTC
                name={"pluWeightProduct"}
                tDefault={"PLU Weight Product"}
                tKey={"producten.form.algemeen.label.pluWeightProduct"}
              />
              <FormSwitchTC
                name={"settings.isServiceProduct"}
                tDefault={"Product is presented as a service request in app"}
                tKey={"producten.form.algemeen.label.isServiceProduct"}
              />
              <FormSwitchTC
                name={"not_available"}
                tDefault={"Not available"}
                tKey={"producten.form.algemeen.label.not_available"}
              />
              <FormSwitchTC
                name={"custom_data.disable_multi_area_sync"}
                tDefault={"Disable multi area sync for this product"}
                tKey={"producten.form.algemeen.label.disable_multi_area_sync"}
              />
            </GridLegacy>

            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Prices"} tKey={"producten.form.algemeen.title.prices"} />
              </h3>
            </GridLegacy>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormControlledInputTC
                name={"prijs"}
                tDefault={"Prijs"}
                tKey={"producten.form.algemeen.label.prijs"}
                type={"currency"}
              />
              <FormControlledInputTC
                name={"prijsEatIn"}
                tDefault={"Price eat in"}
                tKey={"producten.form.algemeen.label.prijsEatIn"}
                type={"currency"}
              />
              <FormControlledInputTC
                name={"prijsDelivery"}
                tDefault={"Price delivery"}
                tKey={"producten.form.algemeen.label.prijsDelivery"}
                type={"currency"}
              />
              <FormControlledInputTC
                name={"prijsTakeaway"}
                tDefault={"Price takeaway"}
                tKey={"producten.form.algemeen.label.prijsTakeaway"}
                type={"currency"}
              />
              <FormControlledInputTC
                name={"vap"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Prijs vanaf"}
                tKey={"producten.form.algemeen.label.prijsva"}
                type={"currency"}
              />
            </GridLegacy>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormControlledInputTC
                name={"vatPercentage"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={" %"}
                tDefault={"BTW"}
                tKey={"producten.form.algemeen.label.vatPercentage"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"vatEatIn"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={" %"}
                tDefault={"VAT eat in"}
                tKey={"producten.form.algemeen.label.vatEatIn"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"vatDelivery"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={" %"}
                tDefault={"VAT delivery"}
                tKey={"producten.form.algemeen.label.vatDelivery"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"vatTakeaway"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={" %"}
                tDefault={"VAT takeaway"}
                tKey={"producten.form.algemeen.label.vatTakeaway"}
                type={"number"}
              />
              <FormSwitchTC
                name={"freeDelivery"}
                tDefault={"Gratis bezorgen"}
                tKey={"producten.form.algemeen.label.freeDelivery"}
              />
              <FormSwitchTC
                name={"freeTransactionCost"}
                tDefault={"Free transaction cost (fixed transaction price only)"}
                tKey={"producten.form.algemeen.label.freeTransactionCost"}
              />
            </GridLegacy>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormSwitchTC
                name={"canAlwaysOrder"}
                tDefault={"Can always order"}
                tKey={"producten.form.algemeen.label.canAlwaysOrder"}
              />
              <FormControlledInputTC
                name={"waitTime"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={" min"}
                tDefault={"Wachtijd bestelling"}
                tKey={"producten.form.algemeen.label.waitTime"}
                type={"number"}
              />
            </GridLegacy>
            <GridLegacy alignContent={"flex-start"} container item lg={6} xs={12}>
              <FormControlledInputTC
                name={"maxOrder"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Max order count"}
                tKey={"producten.form.algemeen.label.maxOrder"}
                type={"number"}
              />
              <FormControlledInputTC
                name={"maxOrderGroup"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Max order group"}
                tKey={"producten.form.algemeen.label.maxOrderGroup"}
                type={"number"}
              />

              <FormControlledInputTC
                name={"requireAge"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                suffix={getTranslation("producten.form.years.suffix", " years")}
                tDefault={"Leeftijdscheck"}
                tKey={"producten.form.algemeen.label.requireAge"}
                type={"number"}
              />
            </GridLegacy>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
